import React from 'react'
import { Modal as ModalSemantic } from 'semantic-ui-react'

import { Close } from 'components/Icons'
import mergeStyles from '@web/helpers/mergeStyles'
import themeStyles from 'components/Modal/styles'
import { useTheme } from 'contexts/ThemeProvider'

const Modal = props => {
  const { theme } = useTheme()
  const defaultStyles = themeStyles(theme)
  const styles = mergeStyles(defaultStyles, props.style)
  return (
    <ModalSemantic
      id={props.id}
      onClose={props.onClose}
      onOpen={props.onOpen}
      open={props.open}
      trigger={props.trigger}
      size={props.size}
      style={{ width: props.width }}
      closeOnDimmerClick={!props.requireAction}
    >
      {props.header &&
        <ModalSemantic.Header style={styles.header}>
          {props.header}
          <Close
            color={theme.primary}
            style={styles.closeIcon}
            onClick={props.onClose}
          />
        </ModalSemantic.Header>
      }
      <ModalSemantic.Content
        className={props.contentClassName}
        style={styles.content}
        scrolling={!props.withoutScrolling}
      >
        {props.children}
      </ModalSemantic.Content>
      {props.buttons &&
        <ModalSemantic.Actions
          style={{ ...styles.buttonsContainer, ...props.buttonsContainerStyle }}
        >
          {props.buttons}
        </ModalSemantic.Actions>
       }
    </ModalSemantic>
  )
}

export default Modal
